function createCustomError(e) {
  function n(e, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = n;
  }
  return n.prototype = new Error(), n.prototype.name = e, n.prototype.constructor = n, n;
}
var LDUnexpectedResponseError = createCustomError("LaunchDarklyUnexpectedResponseError"),
  LDInvalidEnvironmentIdError = createCustomError("LaunchDarklyInvalidEnvironmentIdError"),
  LDInvalidUserError = createCustomError("LaunchDarklyInvalidUserError"),
  LDInvalidEventKeyError = createCustomError("LaunchDarklyInvalidEventKeyError"),
  LDInvalidArgumentError = createCustomError("LaunchDarklyInvalidArgumentError"),
  LDFlagFetchError = createCustomError("LaunchDarklyFlagFetchError");
function isHttpErrorRecoverable(e) {
  return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
}
for (var fromByteArray_1 = fromByteArray, lookup = [], revLookup = [], code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, len = code.length; i < len; ++i) lookup[i] = code[i], revLookup[code.charCodeAt(i)] = i;
function tripletToBase64(e) {
  return lookup[e >> 18 & 63] + lookup[e >> 12 & 63] + lookup[e >> 6 & 63] + lookup[63 & e];
}
function encodeChunk(e, n, t) {
  for (var r, o = [], a = n; a < t; a += 3) r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(tripletToBase64(r));
  return o.join("");
}
function fromByteArray(e) {
  for (var n, t = e.length, r = t % 3, o = [], a = 0, i = t - r; a < i; a += 16383) o.push(encodeChunk(e, a, a + 16383 > i ? i : a + 16383));
  return 1 === r ? (n = e[t - 1], o.push(lookup[n >> 2] + lookup[n << 4 & 63] + "==")) : 2 === r && (n = (e[t - 2] << 8) + e[t - 1], o.push(lookup[n >> 10] + lookup[n >> 4 & 63] + lookup[n << 2 & 63] + "=")), o.join("");
}
revLookup["-".charCodeAt(0)] = 62, revLookup["_".charCodeAt(0)] = 63;
var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  fastDeepEqual = function e(n, t) {
    if (n === t) return !0;
    var r,
      o = Array.isArray(n),
      a = Array.isArray(t);
    if (o && a) {
      if (n.length != t.length) return !1;
      for (r = 0; r < n.length; r++) if (!e(n[r], t[r])) return !1;
      return !0;
    }
    if (o != a) return !1;
    if (n && t && "object" === (void 0 === n ? "undefined" : _typeof(n)) && "object" === (void 0 === t ? "undefined" : _typeof(t))) {
      var i = Object.keys(n);
      if (i.length !== Object.keys(t).length) return !1;
      var s = n instanceof Date,
        u = t instanceof Date;
      if (s && u) return n.getTime() == t.getTime();
      if (s != u) return !1;
      var c = n instanceof RegExp,
        l = t instanceof RegExp;
      if (c && l) return n.toString() == t.toString();
      if (c != l) return !1;
      for (r = 0; r < i.length; r++) if (!Object.prototype.hasOwnProperty.call(t, i[r])) return !1;
      for (r = 0; r < i.length; r++) if (!e(n[i[r]], t[i[r]])) return !1;
      return !0;
    }
    return !1;
  },
  _extends = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  };
function btoa(e) {
  var n = unescape(encodeURIComponent(e));
  return fromByteArray_1(stringToBytes(n));
}
function stringToBytes(e) {
  for (var n = [], t = 0; t < e.length; t++) n.push(e.charCodeAt(t));
  return n;
}
function base64URLEncode(e) {
  return btoa(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function clone(e) {
  return JSON.parse(JSON.stringify(e));
}
function deepEquals(e, n) {
  return fastDeepEqual(e, n);
}
function onNextTick(e) {
  setTimeout(e, 0);
}
function wrapPromiseCallback(e, n) {
  var t = e.then(function (e) {
    return n && setTimeout(function () {
      n(null, e);
    }, 0), e;
  }, function (e) {
    if (!n) return Promise.reject(e);
    setTimeout(function () {
      n(e, null);
    }, 0);
  });
  return n ? void 0 : t;
}
function transformValuesToVersionedValues(e) {
  var n = {};
  for (var t in e) e.hasOwnProperty(t) && (n[t] = {
    value: e[t],
    version: 0
  });
  return n;
}
function transformVersionedValuesToValues(e) {
  var n = {};
  for (var t in e) e.hasOwnProperty(t) && (n[t] = e[t].value);
  return n;
}
function chunkUserEventsForUrl(e, n) {
  for (var t = n.slice(0), r = [], o = e, a = void 0; t.length > 0;) {
    for (a = []; o > 0;) {
      var i = t.shift();
      if (!i) break;
      (o -= base64URLEncode(JSON.stringify(i)).length) < 0 && a.length > 0 ? t.unshift(i) : a.push(i);
    }
    o = e, r.push(a);
  }
  return r;
}
function getLDUserAgentString() {
  return "JSClient/2.8.0";
}
function addLDHeaders(e) {
  e.setRequestHeader("X-LaunchDarkly-User-Agent", getLDUserAgentString());
}
function extend() {
  for (var e = arguments.length, n = Array(e), t = 0; t < e; t++) n[t] = arguments[t];
  return n.reduce(function (e, n) {
    return _extends({}, e, n);
  }, {});
}
var MAX_URL_LENGTH = 2e3;
function EventSender(e, n, t, r) {
  var o = void 0,
    a = e + "/events/bulk/" + n,
    i = e + "/a/" + n + ".gif",
    s = {};
  function u(e, n) {
    var t = new window.Image();
    n && t.addEventListener("load", n), t.src = e;
  }
  function c(e, n, t) {
    var o = r || u,
      s = JSON.stringify(e),
      c = function (e) {
        if (n) (function n(r) {
          var o = new window.XMLHttpRequest();
          return o.open("POST", a, !t), addLDHeaders(o), o.setRequestHeader("Content-Type", "application/json"), o.setRequestHeader("X-LaunchDarkly-Event-Schema", "3"), t || (o.addEventListener("load", function () {
            o.status >= 400 && isHttpErrorRecoverable(o.status) && r ? n(!1).send(s) : e(function (e) {
              var n = {
                  status: e.status
                },
                t = e.getResponseHeader("Date");
              if (t) {
                var r = Date.parse(t);
                r && (n.serverTime = r);
              }
              return n;
            }(o));
          }), r && o.addEventListener("error", function () {
            n(!1).send(s);
          })), o;
        })(!0).send(s);else {
          var r = i + "?d=" + base64URLEncode(s);
          o(r, t ? null : e);
        }
      };
    if (!t) return new Promise(function (e) {
      c(e);
    });
    c();
  }
  return s.sendEvents = function (n, r) {
    void 0 === o && (o = void 0 === t ? "withCredentials" in new window.XMLHttpRequest() : t);
    var a = void 0 !== r && r,
      i = void 0;
    i = o ? [n] : chunkUserEventsForUrl(MAX_URL_LENGTH - e.length, n);
    for (var s = [], u = 0; u < i.length; u++) s.push(c(i[u], o, a));
    return r ? Promise.resolve() : Promise.all(s);
  }, s;
}
function EventSummarizer() {
  var e = {},
    n = 0,
    t = 0,
    r = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var o = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
        a = r[o];
      a ? a.count = a.count + 1 : r[o] = {
        count: 1,
        key: e.key,
        variation: e.variation,
        version: e.version,
        value: e.value,
        default: e.default
      }, (0 === n || e.creationDate < n) && (n = e.creationDate), e.creationDate > t && (t = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {},
      o = !0;
    for (var a in r) {
      var i = r[a],
        s = e[i.key];
      s || (s = {
        default: i.default,
        counters: []
      }, e[i.key] = s);
      var u = {
        value: i.value,
        count: i.count
      };
      void 0 !== i.variation && null !== i.variation && (u.variation = i.variation), i.version ? u.version = i.version : u.unknown = !0, s.counters.push(u), o = !1;
    }
    return o ? null : {
      startDate: n,
      endDate: t,
      features: e
    };
  }, e.clearSummary = function () {
    n = 0, t = 0, r = {};
  }, e;
}
var docLink = " Please see https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client for instructions on SDK initialization.",
  localStorageUnavailable = function () {
    return "localStorage is unavailable";
  },
  unknownCustomEventKey = function (e) {
    return 'Custom event "' + e + '" does not exist';
  },
  environmentNotFound = function () {
    return "environment not found." + docLink;
  },
  environmentNotSpecified = function () {
    return "No environment specified." + docLink;
  },
  errorFetchingFlags = function (e) {
    return "Error fetching flag settings: " + (e.message || e);
  },
  userNotSpecified = function () {
    return "No user specified." + docLink;
  },
  invalidUser = function () {
    return "Invalid user specified." + docLink;
  },
  bootstrapOldFormat = function () {
    return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + docLink;
  },
  bootstrapInvalid = function () {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  deprecated = function (e, n) {
    return '[LaunchDarkly] "' + e + '" is deprecated, please use "' + n + '"';
  },
  httpErrorMessage = function (e, n, t) {
    return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + n + " - " + (isHttpErrorRecoverable(e) ? t : "giving up permanently");
  };
function UserFilter(e) {
  var n = {},
    t = void 0 !== e.allAttributesPrivate ? e.allAttributesPrivate : e.all_attributes_private,
    r = (void 0 !== e.privateAttributeNames ? e.privateAttributeNames : e.private_attribute_names) || [],
    o = {
      key: !0,
      custom: !0,
      anonymous: !0
    },
    a = {
      key: !0,
      secondary: !0,
      ip: !0,
      country: !0,
      email: !0,
      firstName: !0,
      lastName: !0,
      avatar: !0,
      name: !0,
      anonymous: !0,
      custom: !0
    };
  return void 0 !== e.all_attributes_private && console && console.warn && console.warn(deprecated("all_attributes_private", "allAttributesPrivate")), void 0 !== e.private_attribute_names && console && console.warn && console.warn(deprecated("private_attribute_names", "privateAttributeNames")), n.filterUser = function (e) {
    if (!e) return null;
    var n = e.privateAttributeNames || [],
      i = function (e, a) {
        return Object.keys(e).reduce(function (i, s) {
          var u = i;
          return a(s) && (!function (e) {
            return !o[e] && (t || -1 !== n.indexOf(e) || -1 !== r.indexOf(e));
          }(s) ? u[0][s] = e[s] : u[1][s] = !0), u;
        }, [{}, {}]);
      },
      s = i(e, function (e) {
        return a[e];
      }),
      u = s[0],
      c = s[1];
    if (e.custom) {
      var l = i(e.custom, function () {
        return !0;
      });
      u.custom = l[0], c = extend({}, c, l[1]);
    }
    var v = Object.keys(c);
    return v.length && (v.sort(), u.privateAttrs = v), u;
  }, n;
}
function EventProcessor(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
    o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
    a = {},
    i = o || EventSender(e, n),
    s = EventSummarizer(),
    u = UserFilter(t),
    c = !!t.inlineUsersInEvents,
    l = [],
    v = void 0,
    d = void 0,
    f = 0,
    p = !1,
    g = void 0;
  function y(e) {
    onNextTick(function () {
      r && r.maybeReportError(new LDInvalidArgumentError(e));
    });
  }
  function h() {
    return 0 === d || 0 === Math.floor(Math.random() * d);
  }
  return void 0 !== t.samplingInterval && (isNaN(t.samplingInterval) || t.samplingInterval < 0) ? (d = 0, y("Invalid sampling interval configured. Sampling interval must be an integer >= 0.")) : d = t.samplingInterval || 0, void 0 !== t.flushInterval && (isNaN(t.flushInterval) || t.flushInterval < 2e3) ? (v = 2e3, y("Invalid flush interval configured. Must be an integer >= 2000 (milliseconds).")) : v = t.flushInterval || 2e3, a.enqueue = function (e) {
    if (!p) {
      var n,
        t = !1,
        r = !1;
      if (s.summarizeEvent(e), "feature" === e.kind ? h() && (t = !!e.trackEvents, r = !!(n = e).debugEventsUntilDate && n.debugEventsUntilDate > f && n.debugEventsUntilDate > new Date().getTime()) : t = h(), t && l.push(function (e) {
        var n = extend({}, e);
        return c || "identify" === e.kind ? n.user = u.filterUser(e.user) : (n.userKey = e.user.key, delete n.user), "feature" === e.kind && (delete n.trackEvents, delete n.debugEventsUntilDate), n;
      }(e)), r) {
        var o = extend({}, e, {
          kind: "debug"
        });
        delete o.trackEvents, delete o.debugEventsUntilDate, delete o.variation, l.push(o);
      }
    }
  }, a.flush = function (e) {
    if (p) return Promise.resolve();
    var n = l,
      t = s.getSummary();
    return s.clearSummary(), t && (t.kind = "summary", n.push(t)), 0 === n.length ? Promise.resolve() : (l = [], i.sendEvents(n, e).then(function (e) {
      e && (e.serverTime && (f = e.serverTime), isHttpErrorRecoverable(e.status) || (p = !0), e.status >= 400 && onNextTick(function () {
        r.maybeReportError(new LDUnexpectedResponseError(httpErrorMessage(e.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a.start = function () {
    g = setTimeout(function e() {
      a.flush(), g = setTimeout(e, v);
    }, v);
  }, a.stop = function () {
    clearTimeout(g);
  }, a;
}
function EventEmitter() {
  var e = {},
    n = {};
  return e.on = function (e, t, r) {
    n[e] = n[e] || [], n[e] = n[e].concat({
      handler: t,
      context: r
    });
  }, e.off = function (e, t, r) {
    if (n[e]) for (var o = 0; o < n[e].length; o++) n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
  }, e.emit = function (e) {
    if (n[e]) for (var t = 0; t < n[e].length; t++) n[e][t].handler.apply(n[e][t].context, Array.prototype.slice.call(arguments, 1));
  }, e.getEvents = function () {
    return Object.keys(n);
  }, e.getEventListenerCount = function (e) {
    return n[e] ? n[e].length : 0;
  }, e.maybeReportError = function (e) {
    e && (n["error"] ? this.emit("error", e) : console.error(e.message));
  }, e;
}
var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g,
  escapeStringRegexp = function (e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(matchOperatorsRe, "\\$&");
  };
function doesUrlMatch(e, n, t, r) {
  var o = n.replace(t, "").replace(r, ""),
    a = void 0,
    i = void 0;
  switch (e.kind) {
    case "exact":
      i = n, a = new RegExp("^" + escapeStringRegexp(e.url) + "/?$");
      break;
    case "canonical":
      i = o, a = new RegExp("^" + escapeStringRegexp(e.url) + "/?$");
      break;
    case "substring":
      i = o, a = new RegExp(".*" + escapeStringRegexp(e.substring) + ".*$");
      break;
    case "regex":
      i = o, a = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return a.test(i);
}
function findGoalsForClick(e, n) {
  for (var t = [], r = 0; r < n.length; r++) for (var o = e.target, a = n[r], i = a.selector, s = document.querySelectorAll(i); o && s.length > 0;) {
    for (var u = 0; u < s.length; u++) o === s[u] && t.push(a);
    o = o.parentNode;
  }
  return t;
}
function GoalTracker(e, n) {
  for (var t = {}, r = null, o = [], a = 0; a < e.length; a++) for (var i = e[a], s = i.urls || [], u = 0; u < s.length; u++) if (doesUrlMatch(s[u], window.location.href, window.location.search, window.location.hash)) {
    "pageview" === i.kind ? n("pageview", i) : (o.push(i), n("click_pageview", i));
    break;
  }
  return o.length > 0 && (r = function (e) {
    for (var t = findGoalsForClick(e, o), r = 0; r < t.length; r++) n("click", t[r]);
  }, document.addEventListener("click", r)), t.dispose = function () {
    document.removeEventListener("click", r);
  }, t;
}
function Store(e, n, t) {
  var r = {};
  function o() {
    var r = "",
      o = t.getUser();
    return o && (r = n || btoa(JSON.stringify(o))), "ld:" + e + ":" + r;
  }
  return r.loadFlags = function () {
    var e = o(),
      n = void 0,
      t = void 0;
    try {
      n = window.localStorage.getItem(e);
    } catch (e) {
      return console.warn(localStorageUnavailable()), null;
    }
    try {
      t = JSON.parse(n);
    } catch (e) {
      return r.clearFlags(), null;
    }
    if (t) {
      var a = t.$schema;
      (void 0 === a || a < 1) && (t = transformValuesToVersionedValues(t));
    }
    return t;
  }, r.saveFlags = function (e) {
    var n = o(),
      t = extend({}, e, {
        $schema: 1
      });
    try {
      window.localStorage.setItem(n, JSON.stringify(t));
    } catch (e) {
      console.warn(localStorageUnavailable());
    }
  }, r.clearFlags = function () {
    var e = o();
    try {
      window.localStorage.removeItem(e);
    } catch (e) {}
  }, r;
}
function Stream(e, n, t, r) {
  var o = {},
    a = e + "/eval/" + n + "/",
    i = r && r.useReport || !1,
    s = r && r.evaluationReasons || !1,
    u = r && r.streamReconnectDelay || 1e3,
    c = 3e5,
    l = null,
    v = null,
    d = null,
    f = null;
  function p() {
    h(), g(u);
  }
  function g(e) {
    v || (e ? v = setTimeout(y, e) : y());
  }
  function y() {
    var r = void 0,
      o = "";
    if (void 0 !== window.EventSource) {
      i ? r = e + "/ping/" + n : (r = a + base64URLEncode(JSON.stringify(d)), null != t && (o = "h=" + t)), s && (o = o + (o ? "&" : "") + "withReasons=true"), r = r + (o ? "?" : "") + o, h();
      var u = {
        heartbeatTimeout: c,
        silentTimeout: c
      };
      for (var v in l = new window.EventSource(r, u), f) f.hasOwnProperty(v) && l.addEventListener(v, f[v]);
      l.onerror = p;
    }
  }
  function h() {
    l && (l.close(), l = null);
  }
  return o.connect = function (e, n) {
    d = e, f = n, g();
  }, o.disconnect = function () {
    clearTimeout(v), v = null, h();
  }, o.isConnected = function () {
    return l && (l.readyState === window.EventSource.OPEN || l.readyState === window.EventSource.CONNECTING);
  }, o;
}
var json = "application/json";
function fetchJSON(e, n, t, r) {
  var o = new window.XMLHttpRequest(),
    a = void 0;
  return o.addEventListener("load", function () {
    200 === o.status && o.getResponseHeader("Content-type") && 0 === o.getResponseHeader("Content-Type").lastIndexOf(json) ? t(null, JSON.parse(o.responseText)) : t(getResponseError(o));
  }), o.addEventListener("error", function () {
    t(getResponseError(o));
  }), n ? (o.open("REPORT", e), o.setRequestHeader("Content-Type", "application/json"), a = JSON.stringify(n)) : o.open("GET", e), r && addLDHeaders(o), o.send(a), o;
}
function getResponseError(e) {
  return 404 === e.status ? new LDInvalidEnvironmentIdError(environmentNotFound()) : e.statusText;
}
function Requestor(e, n, t, r, o) {
  var a = void 0,
    i = void 0,
    s = {
      fetchFlagSettings: function (s, u, c) {
        var l = void 0,
          v = void 0,
          d = "",
          f = void 0,
          p = void 0;
        t ? (v = [e, "/sdk/evalx/", n, "/user"].join(""), f = s) : (l = base64URLEncode(JSON.stringify(s)), v = [e, "/sdk/evalx/", n, "/users/", l].join("")), u && (d = "h=" + u), r && (d = d + (d ? "&" : "") + "withReasons=true"), v = v + (d ? "?" : "") + d;
        var g,
          y,
          h = (g = c, function (e, n) {
            g(e, n), a = null, i = null;
          });
        a ? (a.abort(), y = i, p = function () {
          y && y.apply(null, arguments), h.apply(null, arguments);
        }) : p = h, i = p, a = fetchJSON(v, f, p, o);
      },
      fetchGoals: function (t) {
        fetchJSON([e, "/sdk/goals/", n].join(""), null, t, o);
      }
    };
  return s;
}
function sanitizeUser(e) {
  var n = clone(e);
  return n.key && (n.key = n.key.toString()), n;
}
function Identity(e, n) {
  var t = {},
    r = void 0;
  return t.setUser = function (e) {
    r = sanitizeUser(e), n(clone(r));
  }, t.getUser = function () {
    return r ? clone(r) : null;
  }, e && t.setUser(e), t;
}
var _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  readyEvent = "ready",
  successEvent = "initialized",
  failedEvent = "failed",
  changeEvent = "change",
  goalsEvent = "goalsReady",
  locationWatcherInterval = 300;
function initialize(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = t.baseUrl || "https://app.launchdarkly.com",
    o = t.eventsUrl || "https://events.launchdarkly.com",
    a = t.streamUrl || "https://clientstream.launchdarkly.com",
    i = t.hash,
    s = R("sendEvents", !0),
    u = R("sendLDHeaders", !0),
    c = !!t.allowFrequentDuplicateEvents,
    l = !!t.sendEventsOnlyForVariation,
    v = void 0 === t.fetchGoals || t.fetchGoals,
    d = e,
    f = EventEmitter(),
    p = Stream(a, d, i, t),
    g = t.eventProcessor || EventProcessor(o, d, t, f),
    y = Requestor(r, d, t.useReport, t.evaluationReasons, u),
    h = {},
    m = "object" === _typeof$1(t.bootstrap) ? function (e) {
      var n = Object.keys(e),
        t = e.$flagsState;
      !t && n.length && console.warn(bootstrapOldFormat());
      !1 === e.$valid && console.warn(bootstrapInvalid());
      var r = {};
      return n.forEach(function (n) {
        if ("$flagsState" !== n && "$valid" !== n) {
          var o = {
            value: e[n]
          };
          t && t[n] ? o = extend(o, t[n]) : o.version = 0, r[n] = o;
        }
      }), r;
    }(t.bootstrap) : {},
    E = void 0,
    k = void 0,
    w = void 0,
    b = void 0,
    S = void 0,
    L = void 0,
    D = !0;
  function R(e, n) {
    return void 0 === t[e] ? n : t[e];
  }
  function U() {
    return s && !function () {
      var e = void 0;
      e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack;
      return "1" === e || "yes" === e;
    }();
  }
  function N(e) {
    e.user ? (D = !1, U() && g.enqueue(e)) : D && (console && console.warn && console.warn("Be sure to call `identify` in the LaunchDarkly client: http://docs.launchdarkly.com/docs/running-an-ab-test#include-the-client-side-snippet"), D = !1);
  }
  var T = Identity(n, function (e) {
      e && N({
        kind: "identify",
        key: e.key,
        user: e,
        creationDate: new Date().getTime()
      });
    }),
    x = Store(d, i, T);
  function F(e, n, t) {
    var r = T.getUser(),
      o = new Date(),
      a = n ? n.value : null;
    if (!c) {
      var i = JSON.stringify(a) + (r && r.key ? r.key : "") + e,
        s = h[i];
      if (s && o - s < 3e5) return;
      h[i] = o;
    }
    var u = {
        kind: "feature",
        key: e,
        user: r,
        value: a,
        variation: n ? n.variationIndex : null,
        default: t,
        creationDate: o.getTime(),
        reason: n ? n.reason : null
      },
      l = m[e];
    l && (u.version = l.flagVersion ? l.flagVersion : l.version, u.trackEvents = l.trackEvents, u.debugEventsUntilDate = l.debugEventsUntilDate), N(u);
  }
  function O(e, n) {
    var t = {
      kind: e,
      key: n.key,
      data: null,
      url: window.location.href,
      user: T.getUser(),
      creationDate: new Date().getTime()
    };
    return "click" === e && (t.selector = n.selector), N(t);
  }
  function I(e, n, t) {
    var r = void 0;
    if (m && m.hasOwnProperty(e) && m[e] && !m[e].deleted) {
      var o = m[e];
      r = C(o), null !== o.value && void 0 !== o.value || (r.value = n);
    } else r = {
      value: n,
      variationIndex: null,
      reason: {
        kind: "ERROR",
        errorKind: "FLAG_NOT_FOUND"
      }
    };
    return t && F(e, r, n), r;
  }
  function C(e) {
    return {
      value: e.value,
      variationIndex: void 0 === e.variation ? null : e.variation,
      reason: e.reason || null
    };
  }
  function A() {
    b = !0, T.getUser() && p.connect(T.getUser(), {
      ping: function () {
        y.fetchFlagSettings(T.getUser(), i, function (e, n) {
          e && f.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), _(n);
        });
      },
      put: function (e) {
        _(JSON.parse(e.data));
      },
      patch: function (e) {
        var n = JSON.parse(e.data),
          t = m[n.key];
        if (!t || !t.version || !n.version || t.version < n.version) {
          var r = {},
            o = extend({}, n);
          delete o.key, m[n.key] = o;
          var a = C(o);
          r[n.key] = t ? {
            previous: t.value,
            current: a
          } : {
            current: a
          }, j(r);
        }
      },
      delete: function (e) {
        var n = JSON.parse(e.data);
        if (!m[n.key] || m[n.key].version < n.version) {
          var t = {};
          m[n.key] && !m[n.key].deleted && (t[n.key] = {
            previous: m[n.key].value
          }), m[n.key] = {
            version: n.version,
            deleted: !0
          }, j(t);
        }
      }
    });
  }
  function P() {
    b && (p.disconnect(), b = !1);
  }
  function _(e) {
    var n = {};
    if (e) {
      for (var t in m) m.hasOwnProperty(t) && m[t] && (e[t] && !deepEquals(e[t].value, m[t].value) ? n[t] = {
        previous: m[t].value,
        current: C(e[t])
      } : e[t] && !e[t].deleted || (n[t] = {
        previous: m[t].value
      }));
      for (var r in e) e.hasOwnProperty(r) && e[r] && (!m[r] || m[r].deleted) && (n[r] = {
        current: C(e[r])
      });
      m = e, j(n);
    }
  }
  function j(e) {
    var n = Object.keys(e);
    if (k && x.saveFlags(m), n.length > 0) {
      var t = {};
      n.forEach(function (n) {
        var r = e[n].current,
          o = r ? r.value : void 0,
          a = e[n].previous;
        f.emit(changeEvent + ":" + n, o, a), t[n] = r ? {
          current: o,
          previous: a
        } : {
          previous: a
        };
      }), f.emit(changeEvent, t), l || n.forEach(function (n) {
        F(n, e[n].current);
      });
    }
  }
  function H(e) {
    var n = null === e ? void 0 : e;
    if (n !== S) {
      var t = (S = n) || L && void 0 === S;
      t && !b ? A() : !t && b && P();
    }
  }
  function J(e) {
    return e === changeEvent || e.substr(0, changeEvent.length + 1) === changeEvent + ":";
  }
  function q() {
    E && E.dispose(), w && w.length && (E = GoalTracker(w, O));
  }
  function z() {
    void 0 !== t.streaming && H(t.streaming), f.emit(readyEvent), f.emit(successEvent);
  }
  function G(e) {
    f.maybeReportError(e), f.emit(failedEvent, e), f.emit(readyEvent);
  }
  function V() {
    s && g.start();
  }
  e || onNextTick(function () {
    f.maybeReportError(new LDInvalidEnvironmentIdError(environmentNotSpecified()));
  }), n ? n.key || onNextTick(function () {
    f.maybeReportError(new LDInvalidUserError(invalidUser()));
  }) : onNextTick(function () {
    f.maybeReportError(new LDInvalidUserError(userNotSpecified()));
  }), "object" === _typeof$1(t.bootstrap) ? onNextTick(z) : "string" == typeof t.bootstrap && "LOCALSTORAGE" === t.bootstrap.toUpperCase() && window.localStorage ? (k = !0, null === (m = x.loadFlags()) ? (m = {}, y.fetchFlagSettings(T.getUser(), i, function (e, n) {
    e ? G(new LDFlagFetchError(errorFetchingFlags(e))) : (n ? _(n) : m = {}, z());
  })) : (onNextTick(z), y.fetchFlagSettings(T.getUser(), i, function (e, n) {
    e && f.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), n && _(n);
  }))) : y.fetchFlagSettings(T.getUser(), i, function (e, n) {
    e ? (m = {}, G(new LDFlagFetchError(errorFetchingFlags(e)))) : (m = n || {}, z());
  }), v && y.fetchGoals(function (e, n) {
    e && f.maybeReportError(new LDUnexpectedResponseError((e.message, e.message))), n && n.length > 0 && (E = GoalTracker(w = n, O), function (e, n) {
      var t = window.location.href,
        r = void 0;
      function o() {
        (r = window.location.href) !== t && (t = r, n());
      }
      !function e(n, t) {
        n(), setTimeout(function () {
          e(n, t);
        }, t);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(locationWatcherInterval, q)), f.emit(goalsEvent);
  }), "complete" !== document.readyState ? window.addEventListener("load", V) : V(), window.addEventListener("beforeunload", function () {
    s && (g.stop(), g.flush(!0));
  }), window.addEventListener("message", function (e) {
    if (e.origin === r && "SYN" === e.data.type) {
      window.editorClientBaseUrl = r;
      var n = document.createElement("script");
      n.type = "text/javascript", n.async = !0, n.src = r + e.data.editorClientUrl;
      var t = document.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(n, t);
    }
  });
  var $ = new Promise(function (e) {
      var n = f.on(readyEvent, function () {
        f.off(readyEvent, n), e();
      });
    }),
    B = new Promise(function (e) {
      var n = f.on(goalsEvent, function () {
        f.off(goalsEvent, n), e();
      });
    }),
    M = new Promise(function (e, n) {
      var t = f.on(successEvent, function () {
          f.off(successEvent, t), e();
        }),
        r = f.on(failedEvent, function (e) {
          f.off(failedEvent, r), n(e);
        });
    });
  return {
    waitForInitialization: function () {
      return M;
    },
    waitUntilReady: function () {
      return $;
    },
    waitUntilGoalsReady: function () {
      return B;
    },
    identify: function (e, n, t) {
      return k && x.clearFlags(), wrapPromiseCallback(new Promise(function (t, r) {
        if (e && null !== e.key && void 0 !== e.key) T.setUser(e), y.fetchFlagSettings(T.getUser(), n, function (e, n) {
          if (e) return f.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), r(e);
          n && _(n), t(transformVersionedValuesToValues(n)), b && A();
        });else {
          var o = new LDInvalidUserError(e ? invalidUser() : userNotSpecified());
          f.maybeReportError(o), r(o);
        }
      }), t);
    },
    variation: function (e, n) {
      return I(e, n, !0).value;
    },
    variationDetail: function (e, n) {
      return I(e, n, !0);
    },
    track: function (e, n) {
      "string" == typeof e ? (w && !function (e) {
        if (!w || 0 === w.length) return !1;
        for (var n = 0; n < w.length; n++) if ("custom" === w[n].kind && w[n].key === e) return !0;
        return !1;
      }(e) && console.warn(unknownCustomEventKey(e)), N({
        kind: "custom",
        key: e,
        data: n,
        user: T.getUser(),
        url: window.location.href,
        creationDate: new Date().getTime()
      })) : f.maybeReportError(new LDInvalidEventKeyError(unknownCustomEventKey(e)));
    },
    on: function (e, n, t) {
      J(e) ? (L = !0, b || void 0 !== S || A(), f.on(e, n, t)) : f.on.apply(f, arguments);
    },
    off: function (e) {
      if (f.off.apply(f, arguments), J(e)) {
        var n = !1;
        f.getEvents().forEach(function (e) {
          J(e) && f.getEventListenerCount(e) > 0 && (n = !0);
        }), n || (L = !1, b && void 0 === S && P());
      }
    },
    setStreaming: H,
    flush: function (e) {
      return wrapPromiseCallback(new Promise(function (e) {
        return s ? e(g.flush()) : e();
      }, e));
    },
    allFlags: function () {
      var e = {};
      if (!m) return e;
      for (var n in m) m.hasOwnProperty(n) && (e[n] = I(n, null, !l).value);
      return e;
    }
  };
}
var version = "2.8.0";
function deprecatedInitialize(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return console && console.warn && console.warn(deprecated("default export", "named LDClient export")), initialize(e, n, t);
}
var index = {
  initialize: deprecatedInitialize,
  version: version
};
export default index;
export { initialize, version };